module.exports = __webpack_public_path__ + "d06002eaf0a5b8a79308ddd4dcec9716.pdf";